import { render, staticRenderFns } from "./EditSelectedNews.vue?vue&type=template&id=2afce745&scoped=true&"
import script from "./EditSelectedNews.vue?vue&type=script&lang=js&"
export * from "./EditSelectedNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afce745",
  null
  
)

export default component.exports